<div class="relations-tab-content">
  <!-- Parents Section -->
  <div class="relations-section parents-section">
    <div class="section-header" (click)="toggleParents()">
      <div class="header-content">
        <i class="material-icons expand-icon" [class.expanded]="parentsExpanded">expand_more</i>
        <h3 class="section-title">Parents</h3>
      </div>
    </div>
    <div class="section-body" *ngIf="parentsExpanded">
      <app-parent-section #parentSection></app-parent-section>
    </div>
  </div>

  <!-- Children Section -->
  <div class="relations-section children-section">
    <div class="section-header" (click)="toggleChildren()">
      <div class="header-content">
        <i class="material-icons expand-icon" [class.expanded]="childrenExpanded">expand_more</i>
        <h3 class="section-title">Children</h3>
      </div>
    </div>
    <div class="section-body" *ngIf="childrenExpanded">
      <app-children-section #childrenSection></app-children-section>
    </div>
  </div>

  <!-- Merged Section -->
  <div class="relations-section merged-section">
    <div class="section-header" (click)="toggleMerged()">
      <div class="header-content">
        <i class="material-icons expand-icon" [class.expanded]="mergedExpanded">expand_more</i>
        <h3 class="section-title">Merged</h3>
      </div>
    </div>
    <div class="section-body" *ngIf="mergedExpanded">
      <app-merge-section #mergeSection></app-merge-section>
    </div>
  </div>
</div>
